import { Col, Container, Row } from "react-bootstrap";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";
import classes from "./styles.module.scss";
import clsx from "classnames";
import Image from "@/ui/Image";

export const SpecialismPageGridSection = ({ className, item }) => {
  const pathPrefix = `page.${item.url_slug}`;
  const locale = useLocale();

  return (
    <div className={clsx(className, classes.content)}>
      <Container>
        <Row className="py-md-5 mb-md-5">
          <Col xs={12} md={6} className={clsx(classes.content__image, "p-5")}>
            <Image
              img={{ path: `${pathPrefix}.section-1.image`, src: "/assets/specialism/1.jpg" }}
              size="x1000"
              alt=""
            />
          </Col>
          <Col xs={12} md={6} className="p-5 bg-primary text-white text-overlay">
            <DynamicHtml path={`${pathPrefix}.section-1.text.${locale}`} className="text-overlay__content mb-4" />
            <Image
              className="text-overlay__background"
              img={{ path: `${pathPrefix}.section-1.bg`, src: "/assets/grid/transparent.png" }}
              size="x1000"
              alt=""
            />
          </Col>
        </Row>
        <Row className="flex-column flex-md-row-reverse">
          <Col xs={12} md={6} className={clsx(classes.content__image, "p-5")}>
            <Image
              img={{ path: `${pathPrefix}.section-2.image`, src: "/assets/specialism/1.jpg" }}
              size="x1000"
              alt=""
            />
          </Col>
          <Col xs={12} md={6} className="p-5 bg-light text-overlay">
            <DynamicHtml className="text-overlay__content" path={`${pathPrefix}.section-2.text.${locale}`} />
            <Image
              className="text-overlay__background"
              img={{ path: `${pathPrefix}.section-2.bg`, src: "/assets/grid/bg.png" }}
              size="x1000"
              alt=""
            />
          </Col>
        </Row>
        <Row className="py-md-5 my-md-5">
          <Col xs={12} md={6} className={clsx(classes.content__image, "p-5")}>
            <Image
              img={{ path: `${pathPrefix}.section-3.image`, src: "/assets/specialism/1.jpg" }}
              size="x1000"
              alt=""
            />
          </Col>
          <Col xs={12} md={6} className="p-5 bg-secondary text-white text-overlay">
            <DynamicHtml path={`${pathPrefix}.section-3.text.${locale}`} className="text-overlay__content mb-md-5" />
            <Image
              className="text-overlay__background"
              img={{ path: `${pathPrefix}.section-3.bg`, src: "/assets/grid/transparent.png" }}
              size="x1000"
              alt=""
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

SpecialismPageGridSection.defaultProps = {
  className: "pb-md-5 mb-md-5",
};
